<div class="login-auth">
  <div class="loginInner1 authentication">
    <div class="log-logo m-b-20 text-center">
      <img src="assets/images/whitelabel.png" class="logo-login" />
    </div>
    <div class="featured-box-login featured-box-secundary default">
      <h3 class="text-center">Security Code Verification</h3>
      <div class="mt-3 text-center">
        Enter 6-digit code from your security auth verification App
      </div>
      <form
        role="form"
        autocomplete="off"
        method="post"
        (ngSubmit)="submitOtp()"
        #otpForm="ngForm"
        class="mt-3 otp-form"
      >
        <div style="display: flex; flex-direction: row">
          <div is-input-num="true" style="display: flex">
            <div
              *ngFor="let i of [1, 2, 3, 4, 5, 6]; let index = index"
              style="display: flex; align-items: center"
            >
              <input
                min="0"
                max="9"
                maxlength="1"
                pattern="[0-9]"
                type="tel"
                class="otp-input"
                [(ngModel)]="otp[index]"
                name="otp{{ index }}"
                (ngModelChange)="onOtpInputChange(index, $event)"
                #otpInput
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
